import { z } from 'zod';

export type OtherString = z.infer<typeof OtherString>;

export const OtherString = z.string() as unknown as z.ZodType<string & { __tag?: unknown }, string>;
